if (!customElements.get('media-progress-bar')) {
  customElements.define(
    'media-progress-bar',
    class MediaProgressBar extends HTMLElement {
      constructor() {
        super();
        this.bar = this.querySelector('.product__media-progress-bar');
        this.galleryId = this.dataset.galleryId;
      }

      connectedCallback() {
        if (!this.galleryId) return;

        this.gallery = document.getElementById(this.galleryId);
        if (!this.gallery) return;

        // Find sibling dots container
        this.dotsContainer = this.parentElement.querySelector('.product__media-dots');
        if (this.dotsContainer) {
          this.dots = this.dotsContainer.querySelectorAll('.product__media-dot');
        }

        this.sliderComponent = this.gallery.querySelector('[id^="GalleryViewer"]');
        if (!this.sliderComponent) return;

        this.slider = this.sliderComponent.querySelector('[id^="Slider-"]');
        if (this.slider) {
          this.init();
        } else {
          this.observer = new MutationObserver(() => {
            this.slider = this.sliderComponent.querySelector('[id^="Slider-"]');
            if (this.slider) {
              this.init();
              this.observer.disconnect();
            }
          });
          this.observer.observe(this.sliderComponent, { childList: true, subtree: true });
        }
      }

      init() {
        this.boundUpdate = this.update.bind(this);
        this.slider.addEventListener('scroll', this.boundUpdate, { passive: true });
        requestAnimationFrame(this.boundUpdate);
      }

      update() {
        if (!this.slider) return;

        const items = this.slider.querySelectorAll('[id^="Slide-"]');
        const visibleItems = Array.from(items).filter((el) => el.clientWidth > 0);
        if (visibleItems.length < 2) return;

        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        if (maxScroll <= 0) return;

        const progress = this.slider.scrollLeft / maxScroll;
        const totalSlides = visibleItems.length;

        // Update progress bar
        if (this.bar) {
          const barWidth = 100 / totalSlides;
          const translateX = progress * (totalSlides - 1) * barWidth;
          this.bar.style.width = barWidth + '%';
          this.bar.style.transform = 'translateX(' + ((translateX / barWidth) * 100) + '%)';
        }

        // Update dots — find nearest slide index
        if (this.dots && this.dots.length > 0) {
          const activeIndex = Math.round(progress * (totalSlides - 1));
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === activeIndex);
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.slider && this.boundUpdate) {
          this.slider.removeEventListener('scroll', this.boundUpdate);
        }
      }
    }
  );
}
